import React from "react";
import { useState, useEffect, useContext, useRef } from "react";
import { UserContext } from "../contexts/user";
import axios from "axios";

import qrcode from "qrcode";
import Loading from "./Loading";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  Table,
  TableCell,
  TableRow,
  TableBody,
  Button,
  TextField,
  Snackbar,
  Box,
  Chip,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";

import PageTitles from "../components/Layout/PageTitles";
import { Typography } from "@mui/material";

export default function ManageMFA() {
  const { user, setUser } = useContext(UserContext);
  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [codeLoading, setCodeLoading] = useState(true);
  const [getNewMfa, setGetNewMfa] = useState(false);
  const [QRcode, setQRcode] = useState(false);
  const [mfaCode, setMfaCode] = useState('');
  const [inputValue, setInputValue] = useState("");
  const [alertColour, setAlertColour] = useState();
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const [errMessage, setErrMessage] = useState("");


  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    axios.get(`/adminUserRec/${user.username}`).then((res) => {
      setUserData(res.data.adminUser);
      if (userData) {
        setIsLoading(false);
      }
    });
  }, []);

  const MFAQRCode = ({ user, mfa, issuer }) => {
    const imgRef = useRef(null);


    useEffect(() => {
      const otpauthUrl = `otpauth://totp/${issuer}:${user}?secret=${mfa}&issuer=${issuer}`;

      qrcode.toDataURL(otpauthUrl, (error, dataUrl) => {
        if (error) {

          return;
        }

        if (imgRef.current) {
          imgRef.current.src = dataUrl;
        }
      });
    }, [user, mfa, issuer]);

    return <img ref={imgRef} alt="MFA QR Code" />;
  };


  const handleEnable = () => {
    
    setGetNewMfa(!getNewMfa);
    axios.get(`/mfa_gen`).then((res) => {
      setMfaCode(res.data);
      setCodeLoading(!codeLoading);
    });
  };

  const handleDisable = () => {
    axios
      .delete(`/mfa_remv`)
      .then((res) => {
        setAlertColour("success");
        setMessage(res.data);
        setOpen(true);
        setUserData({ mfaKey: null });
      
        setGetNewMfa(false);
        setMfaCode('')
        if(!codeLoading){
          setCodeLoading(!codeLoading)
        }
      })
      .catch((err) => {
        setAlertColour("error");
        setMessage(err.response.data);
        setOpen(true);
      });
  };

  const handleInputChange = (event) => {
    event.preventDefault();

    setInputValue(event.target.value);
    setError(false);
  };

  const handleConfirm = (event) => {
    event.preventDefault()
    const regex = /^\d+$/;

    if (inputValue.length < 6 || inputValue.length > 6) {
      setErrMessage("Your code must be 6 numbers");
      setError(true);
      return;
    } else if (regex.test(inputValue) === false) {
      setErrMessage("Your code must contain only numbers");
      setError(true);
      return;
    }

    axios
      .patch(`/mfa_chk/${inputValue}`)
      .then((res) => {
        setAlertColour("success");
        setMessage(res.data);
        setOpen(true);
        setUserData({ mfaKey: true });
        setGetNewMfa(!getNewMfa);
        setMfaCode('')
        setQRcode(!QRcode);
        setCodeLoading(!codeLoading);
      })
      .catch((err) => {
        setAlertColour("error");
        setMessage(err.response.data);
        setOpen(true);
      });
  };

  function CellContent({ mfaKey }) {
    if (mfaKey) {
      return (
        <>
          <CheckCircleIcon fontSize="small" sx={{ color: "#00FF00" }} />
          <Typography>Yes</Typography>
          <Button
            variant="contained"
            size="small"
            sx={{ ml: "10px" }}
            onClick={handleEnable}
            disabled={getNewMfa}
          >
            Resynchronize
          </Button>
          <Button
            variant="contained"
            size="small"
            sx={{ ml: "10px" }}
            onClick={handleDisable}
          >
            Disable
          </Button>
        </>
      );
    } else {
      return (
        <>
          <CancelRoundedIcon fontSize="small" sx={{ color: "#f44336" }} />
          <Typography>No</Typography>
          <Button
            variant="contained"
            size="small"
            sx={{ ml: "10px" }}
            onClick={handleEnable}
            disabled={getNewMfa}
          >
            Enable
          </Button>
        </>
      );
    }
  }

  return (
    <>
      <PageTitles title={"Multi-factor Authentication"} />
      <Grid id="i">
        {isLoading && <Loading />}
        {isLoading === false && (
          <>
            <Snackbar
              open={open}
              autoHideDuration={6000}
              onClose={handleAlertClose}
            >
              {
                <Alert
                  onClose={handleAlertClose}
                  severity={alertColour}
                  sx={{ width: "100%" }}
                >
                  {message}
                </Alert>
              }
            </Snackbar>
            <Grid item m={1}>
              <Paper
                sx={{ p: 2}}
              >
                <Table
                  sx={{
                    mt: "10px",
                    mb: "10px",
                    p: "5px",
                    w: "100%",
                  }}
                >
                  <TableBody sx={{ width: "100%" }}>
                    <TableRow>
                      <TableCell
                        variant="head"
                        className="tableHeader"
                        sx={{ flexGrow: 1 }}
                      >
                        MFA enabled ?
                      </TableCell>
                      <TableCell
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          flexGrow: 2,
                        }}
                      >
                        <CellContent mfaKey={userData.mfaKey} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Paper>
            </Grid>

            <Grid item m={1} sx={{ display: "flex" }}>
              {getNewMfa && (
                <Paper
                  sx={{p: 2, width: "100%"}}
                >
                  {codeLoading && <Loading />}
                  {codeLoading === false && (
                    <Box>
                      <Box sx={{ display: "flex", flexDirection: "row" }}>
                        <Typography>
                          Your code is:</Typography>
                          <Chip
                            label={mfaCode}
                            sx={{ backgroundColor: "#A020F0" , ml:'2px' }}
                          />
                        
                        <Button
                          variant="contained"
                          size="small"
                          sx={{ ml: "10px" }}
                          onClick={() => {
                            setQRcode(!QRcode);
                          }}
                        >
                          {QRcode && "Hide QR code"}
                          {!QRcode && "Show QR code"}
                        </Button>
                      </Box>
                      <Typography sx={{ mt: 2, mb: 2 }}>
                        Once you have set up your MFA app by entering the code
                        above, or scanning the QR code, please enter the
                        six-digit token below and press the Confirm button
                      </Typography>
                      <Box sx={{ display: "flex", flexDirection: "row" }}>
                        <form onSubmit={handleConfirm}>
                          <TextField
                            id="outlined-basic"
                            variant="outlined"
                            sx={{ m: "5px" }}
                            onChange={handleInputChange}
                            error={error}
                            helperText={error ? errMessage : ""}
                          />
                          <Button
                            variant="contained"
                            size="small"
                            sx={{ ml: "10px" }}
                            type="submit"
                          >
                            Confirm
                          </Button>
                        </form>
                      </Box>
                    </Box>
                  )}
                </Paper>
              )}

              {QRcode && (
                <Paper
                  sx={{p: 2 }}
                >
                  <Typography
                    variant="h5"
                    sx={{ color: "#A020F0", fontWeight: "bold" }}
                  >
                    MFA QR code
                  </Typography>
                  <Box>
                    <MFAQRCode
                      user={user['username']}
                      mfa={mfaCode}
                      issuer={"RiskTreeAdmin"}
                    />
                  </Box>
                  <Typography>
                    Scan the QR code above using your MFA application.
                  </Typography>
                </Paper>
              )}
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
}
